import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useBryntumScheduler() {
  const { state, setState: updateGlobalState, getState: getGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.bryntumState, ...args };
    updateGlobalState({ bryntumState: newState });
  };

  const setBryntumScheduler = (schedulerInstance) => setState({ schedulerInstance });

  // The reference outlives the widget: leaving the schedule page destroys the scheduler while this still
  // points at it, and a destroyed widget stays truthy with its internals torn out — so callers guarding on
  // presence alone would reach past their guard into it.
  const getBryntumScheduler = () => {
    const schedulerInstance = getGlobalState().bryntumState.schedulerInstance;

    return schedulerInstance?.isDestroyed ? null : schedulerInstance;
  };

  return {
    getBryntumScheduler,
    setBryntumScheduler,
  };
}
